import React from "react";
export const ZipCode = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0401 1.83745C13.5131 1.31748 12.8203 1.03125 12.0895 1.03125H3.91192C2.38817 1.03125 1.14844 2.27363 1.14844 3.80047V7.68901C1.14844 8.06301 1.45187 8.36643 1.82586 8.36643H7.32327V13.6764H5.47007C5.09608 13.6764 4.79265 13.9798 4.79265 14.3538C4.79265 14.7278 5.09608 15.0312 5.47007 15.0312H10.5313C10.9053 15.0312 11.2087 14.7278 11.2087 14.3538C11.2087 13.9798 10.9053 13.6764 10.5313 13.6764H8.67811V8.36643H14.1755C14.5495 8.36643 14.8529 8.063 14.8529 7.68901V3.80047C14.8529 3.05866 14.5654 2.36271 14.0401 1.83745ZM2.50328 3.80047C2.50328 3.02073 3.13527 2.38609 3.91192 2.38609C4.28768 2.38609 4.64447 2.53383 4.91041 2.79581C5.17855 3.06748 5.3263 3.42427 5.3263 3.80047V7.01159H2.50328V3.80047ZM13.4981 7.01159H6.68114V3.80047C6.68114 3.29668 6.5434 2.8132 6.28893 2.38609H12.0895C12.4617 2.38609 12.8167 2.53383 13.0857 2.79889C13.3517 3.06483 13.4981 3.42074 13.4981 3.80046L13.4981 7.01159Z"
        fill="#775FD5"
        stroke="#775FD5"
        stroke-width="0.5"
      />
    </svg>
  );
};
